/** Company contact numbers — use everywhere phones are shown. */
export const CONTACT_PHONES = ["+91 94871 91563", "+91 90033 02883"];

export const PRIMARY_PHONE = CONTACT_PHONES[0];

export const toTelHref = (phone) => {
  const digits = String(phone || "").replace(/\D/g, "");
  return digits ? `tel:+${digits}` : "#";
};

export const toWhatsAppHref = (phone = PRIMARY_PHONE) => {
  const digits = String(phone || "").replace(/\D/g, "");
  return digits ? `https://wa.me/${digits}` : "https://wa.me/919487191563";
};
